



















































































import { Component, Vue } from 'vue-property-decorator';
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import Marker from 'vue-baidu-map/components/overlays/Marker.vue';
import Scale from 'vue-baidu-map/components/controls/Scale.vue';
import Navigation from 'vue-baidu-map/components/controls/Navigation.vue';
import Control from 'vue-baidu-map/components/controls/Control.vue';
import CityList from 'vue-baidu-map/components/controls/CityList.vue';
import './css/Weather.less';
import API, { getQueryString } from '@/Api/api_data';
import MessageBus from '@/Utils/message/message-bus';
import { eventBus } from '@/main';
import Location from '@/component/weather/baidumap/location';
import { profile } from '@/Utils/profile';
const ieslabDisableRules = profile.get('ieslabDisableRules') === 'true';
const iesDisableRules = profile.get('iesDisableRules') === 'true';

/**
 * @author guan
 * @description 百度地图类
 * @return void
 */
@Component({
    components: {
        'bm-control': Control,
        'bm-navigation': Navigation,
        'bm-marker': Marker,
        'bm-scale': Scale,
        'bm-city-list': CityList,
        'baidu-map': BaiduMap,
    } as never,
})
export default class BaiduMapLocation extends Vue {
    /** 创建一个位置实例  */
    public location = new Location();
    /** 潮流编号 */
    // simu_id = 0;
    /** map初始化 */
    private map;
    /** 备份map */
    private Bmap;
    /** 参数id */
    param_id = 0;
    /** 数据加载效果 */
    spinning = false;
    /** */
    isMapRender = true;
    /** 中心坐标 */
    center = {
        lng: 120.591586,
        lat: 33.20745,
    };

    /**
     *
     */
    get simu_id(): number {
        return Number(this.$route.query.simu_id);
    }
    /**
     * @author guan
     * @description 加载天气数据,保存参数
     * @return void
     */
    private loadWeatherData(): void {
        const params = { lat: this.location.latitude, lng: this.location.longitude, simu_id: this.simu_id };
        this.saveLocation(params);
        this.spinning = true;
        /** 加载天气数据 */
        API.loadWeaterData(params)
            .then(() => {
                this.$router
                    .push({ path: 'weather_data', query: { simu_id: getQueryString()['simu_id'] } })
                    .then(() => {
                        eventBus.$emit('upMenuStates');
                    })
                    .catch((e) => e);
                this.spinning = false;
            })
            .catch(() => {
                this.spinning = false;
                MessageBus.Notification('error', { message: '提示', description: '未知错误' });
            });
    }

    /**
     * @author guan
     * @description 保存输入的参数
     * @return void
     * @param params lng: 经度 lat: 纬度 simu_id: 算例id
     */
    saveLocation(params: { lat: number; lng: number; simu_id: number; id?: number; simu?: number }): void {
        if (this.param_id === 0) {
            params.simu = Number(this.$route.query.simu_id || 0);
            API.postWeatherParam(params).catch((error: Error) => error);
        } else {
            params.id = this.param_id;
            params.simu = getQueryString()['simu_id'] as unknown as number;
            API.putWeatherParam(params);
        }
    }

    /** */
    style = { position: 'absolute', top: '60px !important', right: '10px !important' };
    /** */
    styleLocal: Record<string, string> = { display: 'none', top: '190px !important', right: '10px !important' };

    /**
     * 地图初始化
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    async mapReady({ BMap, map }): Promise<void> {
        const data = await this.getData().catch((e) => e);
        this.center = data;
        this.Bmap = BMap;
        this.map = map;
        this.isMapRender = false;
        this.styleLocal = { top: '190px !important', right: '10px !important' };
        map.enableScrollWheelZoom(true);

        // 地图点击事件
        map.addEventListener('click', (e: { point: { lng: number; lat: number } }) => {
            if (this.location.MARK_MODE) {
                this.location.longitude = e.point.lng;
                this.location.latitude = e.point.lat;
                this.location.marker_position.lng = e.point.lng;
                this.location.marker_position.lat = e.point.lat;
                map.panTo(new BMap.Point(e.point.lng, e.point.lat));
            }
        });
    }
    /**
     * @author guan
     * @description 移动到新的经纬度
     * @return void
     */
    private moveMapMark(): void {
        this.map.panTo(new this.Bmap.Point(this.location.longitude, this.location.latitude), 7); //移动到修改后的经纬度
    }
    /**
     * @author guan
     * @description 返回
     * @return void
     */
    private getBackMarker(): void {
        this.map.panTo(new this.Bmap.Point(this.location.marker_position.lng, this.location.marker_position.lat), 7);
    }

    /**
     * 获取数据
     */
    async getData(): Promise<{ lng: number; lat: number }> {
        const param = { simu: this.simu_id };
        try {
            const res = await API.getWeatherParam(param);
            if (res.results.length > 0) {
                let result = res.results[0];
                this.location.longitude = Number(result.lng);
                this.location.latitude = Number(result.lat);
                this.location.marker_position.lng = Number(result.lng);
                this.location.marker_position.lat = Number(result.lat);
                this.param_id = result.id;
                this.spinning = false;
                return {
                    lng: Number(result.lng),
                    lat: Number(result.lat),
                };
            } else {
                MessageBus.Notification('warning', {
                    message: '算例配置',
                    description: '当前配置并未有经纬度，已创建默认经纬度!',
                    duration: 4,
                    key: '算例未配置',
                });
                return {
                    lng: this.location.longitude,
                    lat: this.location.latitude,
                };
            }
        } catch {
            MessageBus.Notification('error', { message: '提示', description: '接口错误' });
            return {
                lng: this.location.longitude,
                lat: this.location.latitude,
            };
        } finally {
            this.spinning = false;
        }
    }

    /** */
    disabledFunction = false;

    /**
     * 组件挂载
     */
    mounted(): void {
        if (!this.$route.name?.includes('ies')) {
            this.disabledFunction = ieslabDisableRules;
        } else {
            this.disabledFunction = iesDisableRules;
        }
    }
}
